import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import PageLayout from "./components/PageLayout";
import { useShop } from "./context/ShopContext";
import PendingReceivePopup from "./components/PendingReceive";
import PendingTransferPopup from "./components/PendingTransfer";
import "./App.css";

/* Pages that manage their own full-page layout */
const STANDALONE_ROUTES = ["/home", "/pos"];

function PageWrapper() {
  const { pathname } = useLocation();
  if (STANDALONE_ROUTES.includes(pathname)) return <Outlet />;
  return (
    <PageLayout>
      <Outlet />
    </PageLayout>
  );
}

function App() {
  const { shopId } = useShop();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", handle);
    return () => window.removeEventListener("resize", handle);
  }, []);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", background: "#F5F6FA" }}>

      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>

        {/* Mobile top bar */}
        {isMobile && (
          <div style={{
            height: 52, background: "#1a2035", display: "flex",
            alignItems: "center", padding: "0 16px",
            justifyContent: "space-between", flexShrink: 0,
          }}>
            <button onClick={toggleSidebar} style={{
              background: "rgba(255,255,255,0.1)", border: "none",
              borderRadius: 8, color: "#fff", fontSize: 18,
              width: 36, height: 36, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>☰</button>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>🍷 WINESHOP</span>
            <div style={{ width: 36 }} />
          </div>
        )}

        {/* Scrollable page content */}
        <div style={{ flex: 1, overflowY: "auto", overflowX: "clip", WebkitOverflowScrolling: "touch" }}>
          <PageWrapper />
        </div>

      </div>

      {/* Global popups */}
      {shopId && <PendingReceivePopup shopId={shopId} />}
      {shopId && <PendingTransferPopup shopId={shopId} />}
    </div>
  );
}

export default App;
